import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { createEntity, getEntity, reset, updateEntity } from './allowed-companies.reducer';

export const AllowedCompaniesUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const allowedCompaniesEntity = useAppSelector(state => state.allowedCompanies.entity);
  const loading = useAppSelector(state => state.allowedCompanies.loading);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (!isNew && allowedCompaniesEntity) {
      setFormData({
        id: allowedCompaniesEntity?.id,
        company: allowedCompaniesEntity?.company,
      });
    }
  }, [allowedCompaniesEntity]);

  const handleInputChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const handleClose = () => {
    props.history.push('/allowed-companies' + props.location.search);
  };

  const saveEntity = values => {
    const entity = {
      ...allowedCompaniesEntity,
      ...values,
      company: values.company,
    };

    const handleEntityDispatch = async (entityParam, isNewParam: boolean) => {
      try {
        const action = isNewParam ? createEntity(entityParam) : updateEntity(entityParam);
        const { payload }: { payload: { data?: { id?: any } } } = await dispatch(action);
        const entityId = isNewParam ? payload?.data?.id : entityParam.id;

        if (entityId) {
          handleClose();
        }
      } catch (error) {
        console.error('Error when dealing with entity:', error);
      }
    };

    handleEntityDispatch(entity, isNew);
  };

  const handleSubmit = () => {
    event.preventDefault();
    saveEntity(formData);
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.allowedCompanies.home.createOrEditLabel" data-cy="AllowedCompaniesCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.allowedCompanies.home.createOrEditLabel">Create or edit a AllowedCompanies</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <BoxForm onSubmit={handleSubmit}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="allowed-companies-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <FormControlDefault>
                <SelectPaginate
                  label={translate('fleetSenseApp.userCustom.company')}
                  apiUrl={'api/companies/new-truck-implement'} // TODO: Update this URL to dont show the already added
                  onChange={value => handleInputChange('company', value)}
                  value={formData['company']}
                  valueName="name"
                  icon="sort-down"
                  isRequired={true}
                  filterStyle={true}
                  sortQuery={'name'}
                />
              </FormControlDefault>
              <RegisterButton />
            </BoxForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AllowedCompaniesUpdate;
